import { FileText, Lock, ShieldCheck } from "lucide-react";
import { money, STATUS } from "../studioUtils";
import { QuoteHistoryActions } from "./QuoteHistoryActions";
import styles from "../views/QuoteHistory.module.css";

export const QuoteHistoryTable = ({ history, openQuote, updateStatus, actions }) => (
  <div className={styles.tableFrame}>
    <table className={styles.table} data-testid="quote-history-table" aria-label="Teklif geçmişi">
      <colgroup>
        <col className={styles.customerCol} /><col className={styles.referenceCol} />
        <col className={styles.statusCol} /><col className={styles.amountCol} /><col className={styles.actionsCol} />
      </colgroup>
      <thead data-testid="history-table-header"><tr>
        <th scope="col" data-testid="history-heading-customer">Müşteri / Konu</th>
        <th scope="col" data-testid="history-heading-reference">Referans / Tarih</th>
        <th scope="col" data-testid="history-heading-status">Durum</th>
        <th scope="col" className={styles.amountHeading} data-testid="history-heading-amount">Toplam (TL)<small>KDV dahil</small></th>
        <th scope="col" className={styles.actionsHeading} data-testid="history-heading-actions">İşlemler</th>
      </tr></thead>
      <tbody>{history.map(item => {
        const ref = item.ref_code;
        const locked = !!item.customer_approval;
        const status = STATUS.find(s => s.value === item.status) || STATUS[0];
        return <tr key={ref} className={styles.row} data-testid={`history-row-${ref}`}>
          <td className={styles.customerCell} data-testid={`history-customer-cell-${ref}`}>
            <button className={styles.customerButton} data-testid={`saved-quote-${ref}`} onClick={() => openQuote(ref)}>
              <span className={`${styles.documentIcon} ${locked ? styles.lockedIcon : ""}`} aria-hidden="true">
                {locked ? <Lock size={17} /> : <FileText size={17} />}
              </span>
              <span className={styles.customerText}>
                <strong data-testid={`history-customer-name-${ref}`}>{item.customer_name || "İsimsiz müşteri"}</strong>
                <span className={styles.subject} data-testid={`history-subject-${ref}`}>{item.subject || "Teklif"}</span>
                {(item.revision > 0 || locked) && <span className={styles.badges}>
                  {item.revision > 0 && <span className={styles.revision} data-testid={`history-revision-${ref}`}>Rev.{item.revision}</span>}
                  {locked && <span className={styles.approval} data-testid={`history-customer-decision-${ref}`}><ShieldCheck size={11} />Müşteri kararı</span>}
                </span>}
                {item.reminder_count > 0 && <small className={styles.reminderNote} data-testid={`history-reminder-count-${ref}`}>{item.reminder_count} hatırlatma</small>}
              </span>
            </button>
          </td>
          <td className={styles.referenceCell} data-testid={`history-reference-cell-${ref}`}>
            <span className={styles.mobileLabel}>Referans / Tarih</span>
            <button className={styles.referenceButton} data-testid={`history-reference-${ref}`} onClick={() => openQuote(ref)}>{ref}</button>
            <time className={styles.date} dateTime={item.created_at} data-testid={`history-date-${ref}`}>{new Date(item.created_at).toLocaleDateString("tr-TR")}</time>
          </td>
          <td className={styles.statusCell} data-testid={`history-status-cell-${ref}`}>
            <span className={styles.mobileLabel}>Durum</span>
            <select className={styles.statusSelect} data-testid={`status-${ref}`} aria-label={`${ref} teklif durumu`}
              style={{ borderColor: status.color, color: status.color }} value={item.status || "taslak"}
              disabled={locked} title={locked ? "Müşteri kararı verildi, değiştirilemez" : "Teklif durumunu değiştir"}
              onChange={e => updateStatus(ref, e.target.value)}>
              {STATUS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
          </td>
          <td className={styles.amountCell} data-testid={`history-amount-cell-${ref}`}>
            <span className={styles.mobileLabel}>Toplam · KDV dahil</span>
            <b className={styles.amount} data-testid={`history-amount-${ref}`}>{money(item.grand_total)}</b>
          </td>
          <td className={styles.actionsCell} data-testid={`history-actions-cell-${ref}`}>
            <QuoteHistoryActions item={item} {...actions} />
          </td>
        </tr>;
      })}</tbody>
    </table>
  </div>
);